<template>
    <div class="allNav" :style="myStyle?myStyle:styleBox.backgroundColor">
        <div class="mynavContent">
            <div class="returunContent">
                <i class="iconfont icon-fanhui" v-if="returnBlck" @click="retunGoBackOrApp"></i>
            </div>
            <div class="navTitle">
                {{myTitle}}
            </div>
            <!-- 插入自己想要按钮 -->
            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
		myStyle: {  //导航样式
			type: Object,
			default:()=>null, 
			required: false,
        },
        myTitle: {  //标题
			type: String,
			default:()=>"", 
			required: false,
        },
        returnBlck: {  //返回按钮是否显示 //
			type: Boolean,
			default:()=>true, 
			required: false,
        },
        returnApp: {  //是返回到APP还是返回到路由
			type: Boolean,
			default:()=>false, 
			required: false,
        },
    },
    methods:{
        retunGoBackOrApp(){
            if(this.returnApp){ //返回APP
                this.returnPage();
            }else{ //返回路由
                this.goBackPage(this.$router);
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .allNav{
        width: 100%;
        height: 64px;
        padding: 0px 12px;
        padding-top: 24px;
        box-sizing: border-box;
        font-size: 16px;
    }
    .mynavContent{
       width: 100%;
       height: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
    }
</style>